const o = "Campo colore, il colore attuale è {color}", l = "Color field", r = "Colors palette", e = "Colori predefiniti", t = "Custom preset colors", c = "Add color", s = "Svuota il campo colore", i = "Custom color, HEX format", a = "Aggiungi il colore alla lista dei colori personalizzati", C = "Svuota il campo colore personalizzato", n = "Delete color with backspace", d = {
  currentColor: o,
  emptyColor: l,
  palette: r,
  presetColors: e,
  customColors: t,
  addColor: c,
  clearColor: s,
  colorField: i,
  colorFieldConfirm: a,
  colorFieldClear: C,
  deleteColorDescriber: n
};
export {
  c as addColor,
  s as clearColor,
  i as colorField,
  C as colorFieldClear,
  a as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  d as default,
  n as deleteColorDescriber,
  l as emptyColor,
  r as palette,
  e as presetColors
};
